import React, { createContext, useContext, useState } from "react";

const KamiContext = createContext();

export function KamiProvider({ children }) {
  const [focusedGlyph, setFocusedGlyph] = useState(null);
  const [glyphLog, setGlyphLog] = useState([]);
  const [entropyLevel, setEntropyLevel] = useState(0);
  const [commandEcho, setCommandEcho] = useState([]);

  const logGlyph = (glyph) => {
    setGlyphLog((prev) => [...prev, { ...glyph, time: Date.now() }]);
    setFocusedGlyph(glyph);
  };

  const recordCommand = (cmd) => {
    setCommandEcho((prev) => [...prev, { cmd, time: Date.now() }]);
  };

  return (
    <KamiContext.Provider
      value={{
        focusedGlyph,
        logGlyph,
        glyphLog,
        entropyLevel,
        setEntropyLevel,
        commandEcho,
        recordCommand,
      }}
    >
      {children}
    </KamiContext.Provider>
  );
}

export const useKami = () => useContext(KamiContext);
